import { useNavigate } from "react-router-dom";

// funcs
import {
  GenerateVendorInvoiceDownload,
} from "../../../funcs/invoicing/GenerateDownload";

// styles and images
import "../../project/Project.css";
import "../AccountInvoices.css";
import Download from "../../../assets/download.svg";
import Refresh from "../../../assets/refresh.svg";
import DollarSign from "../../../assets/dollar_sign.svg";
import Open from "../../../assets/open.svg";
import BlackDislike from "../../../assets/black-dislike.png";
import BlackLike from "../../../assets/black-like.png";
import AddCircle from "../../../assets/add_circle.svg";
import pdfPic from "../../../assets/pdf_pic.svg";
import Mail from "../../../assets/mail.svg";

// global
import { accountDataStore, dbDataStore, messageAndErrorStore, userStore } from "../../../store/Store";
import Dates from "../../../components/Dates";

export default function AccountVendorInvoiceListRows({
  isAsset,
  setBody,
  setTrigger,
  invoices,
  setTriggerComments,
  setTriggerAdjustment,
  enableCheckBoxes,
  batchInvoices,
  setBatchInvoices,
  setBatchChecked,
  filter,
}) {
  // global
  const accountVendorInvoiceTotals = accountDataStore(
    (data) => data.accountVendorInvoiceTotals,
  );
  const accountCustomerInvoices = accountDataStore(
    (data) => data.accountCustomerInvoices,
  );
  const projectData = dbDataStore((data) => data.projectData);
  const JwtToken = userStore((data) => data.JwtToken);
  const currentUser = userStore((data) => data.currentUser);
  const currentCompany = userStore((data) => data.currentCompany);
  const setAuthStatus = userStore((data) => data.setAuthStatus);
  const invoiceAdjustments = accountDataStore(
    (data) => data.invoiceAdjustments,
  );
  const toggleNewMessage = messageAndErrorStore(data => data.toggleNewMessage)

  // local
  const navigate = useNavigate();

  const handleStatus = (s, invoice) => {
    setBody({
      id: invoice.id,
      invoice_status_id: s,
      invoice_name: invoice.invoice_name,
      invoice_comments: invoice.invoice_comments,
      updated_by_id: currentUser.id,
      is_asset: invoice.is_asset,
    });

    setTrigger(true);
  };
  
  const getInvoiceAction = (invoice) => {
    switch (invoice.invoice_status_id) {
      case 29:
        if (
          (invoice.customer_approval_status_id === 23 ||
          invoice.customer_approval_status_id === 24) && invoice.customer_approval_required
        ) {
          return (
            <img
              className="account-invoice-action"
              src={DollarSign}
              onClick={() => handleStatus(31, invoice)}
              alt="dollar-sign"
            />
          );
        } else if (!invoice.customer_approval_required) {
          return (
            <img
              className="account-invoice-action"
              src={DollarSign}
              onClick={() => handleStatus(31, invoice)}
              alt="dollar-sign"
            />
          );
        }
        break
      case 30:
        return (
          <img
            className="account-invoice-action"
            src={Refresh}
            onClick={() => handleStatus(30, invoice)}
            alt="refresh"
          />
        );
      case 32:
        if (
          (invoice.customer_approval_status_id === 23 ||
            invoice.customer_approval_status_id === 24) &&
            invoice.customer_approval_required
        ) {
          return (
            <div className="d-flex" style={{ margin: "0 0 0 10px" }}>
              <img
                className="account-invoice-action"
                style={{ margin: "0 5px 0 0" }}
                src={BlackLike}
                alt="black-like"
                onClick={() => handleStatus(29, invoice)}
              />{" "}
              <img
                className="account-invoice-action"
                src={BlackDislike}
                style={{ margin: "0 5px 0 0" }}
                alt="black-dislike"
                onClick={() => handleStatus(30, invoice)}
              />
              {invoice.company_type === "Driver" && <img
                className="account-invoice-action"
                src={Mail}
                alt="mail"
                onClick={() => handleMail(invoice)}
              />}
            </div>
          );
        } else if (!currentCompany.customer_approval_required) {
          return (
            <div className="d-flex" style={{ margin: "0 0 0 10px" }}>
              <img
                className="account-invoice-action"
                style={{ margin: "0 5px 0 0" }}
                src={BlackLike}
                alt="black-like"
                onClick={() => handleStatus(29, invoice)}
              />{" "}
              <img
                className="account-invoice-action"
                src={BlackDislike}
                style={{ margin: "0 5px 0 0" }}
                alt="black-dislike"
                onClick={() => handleStatus(30, invoice)}
              />
              {invoice.company_type === "Driver" && <img
                className="account-invoice-action"
                src={Mail}
                alt="mail"
                onClick={() => handleMail(invoice)}
              />}
            </div>
          );
        }
        break
      default:
        return <p></p>;
    }
  };

  const getCustInvInfo = (customerInvId, type) => {
    if (accountCustomerInvoices) {
      const d = accountCustomerInvoices.filter(
        (x) => x.id === customerInvId,
      );
      if (type === "start" && d.length > 0) {
        return d[0].start_date;
      } else if (type === "end" && d.length > 0) {
        return d[0].end_date;
      } else if (type === "cust_invoice" && d.length > 0) {
        return d[0].invoice_name;
      } else {
        return "";
      }
    } else {
      return "";
    }
  };
  const handleDownload = (id) => {
    const controller = new AbortController();
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + JwtToken);
    const requestOptions = {
      method: "GET",
      headers,
      signal: controller.signal,
    };

    fetch(
      `${process.env.REACT_APP_BACKEND}/pc/account-vendor-invoices/${id}`,
      requestOptions,
    )
      .then((res) => {
        if (!res.ok) {
          if (res.status === 401) {
            navigate("/login");
            setAuthStatus(false);
          } else {
            toggleNewMessage("Something went wrong");
            return;
          }
        } else {
          setAuthStatus(true);
          return res.json();
        }
      })
      .then((data) => {
        GenerateVendorInvoiceDownload(
          data.vendor_invoice,
            data.vendor_invoice_loads,
            data.uninvoiced_loads,
            data.uninvoiced_total,
            null,
            data.vendor_invoice.vendor_name,
            projectData,
            data.adjustments,
        )
      })
      .catch((err) => {
        toggleNewMessage(err);
      });
    return () => controller.abort();
  };

  const handlePdf = (inv) => {
    const controller = new AbortController();
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + JwtToken);
    const requestOptions = {
      method: "GET",
      headers,
      signal: controller.signal,
    };

    fetch(
      `${process.env.REACT_APP_BACKEND}/pc/invoice-pdf/${inv.id}?is_vendor=true`,
      requestOptions,
    )
      .then((res) => {
        if (!res.ok) {
          if (res.status === 401) {
            navigate("/login");
            setAuthStatus(false);
          } else {
            toggleNewMessage("Something went wrong");
            return;
          }
        } else {
          setAuthStatus(true);
          return res.blob();
        }
      })
      .then((blob) => {
        if (!blob) {
          return;
        } else {
          const fileName = `${inv.invoice_name}.pdf`;
          const pdfUrl = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = pdfUrl;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(pdfUrl);
        }
      })
      .catch((err) => {
        toggleNewMessage(err);
      });
    return () => controller.abort();
  };

  const handleClick = (id) => {
    navigate(`/account-invoices/vendor/${id}`);
  };
  const getTotals = (inv) => {
    var totals = {
      weight: 0,
      weight_diff: 0,
      cost: 0,
      cost_diff: 0,
      duplicate_tickets: 0,
      missing_tickets: 0,
      locked_loads: 0,
      total_adjustment: 0,
      adjustment_exists: false,
      total_after_adjustment: inv.freight_cost + inv.fsc_cost,
    };
    const total = accountVendorInvoiceTotals.filter(
      (x) => x.invoice_id === inv.id,
    );

    var adj = [];
    if (invoiceAdjustments) {
      adj = invoiceAdjustments.filter((x) => x.invoice_id === inv.id);
    }

    if (total.length > 0) {
      totals.weight = parseFloat(total[0].calculated_weight).toLocaleString(
        "en-US",
        {
          maximumFractionDigits: 2,
        },
      );
      totals.weight_diff = parseFloat(
        inv.total_weight_tons - total[0].calculated_weight,
      ).toLocaleString("en-US", {
        maximumFractionDigits: 2,
      });
      totals.cost = `$${parseFloat(total[0].calculated_cost).toLocaleString(
        "en-US",
        {
          maximumFractionDigits: 2,
        },
      )}`;
      totals.cost_diff = `$${parseFloat(
        inv.freight_cost + inv.fsc_cost - total[0].calculated_cost,
      ).toLocaleString("en-US", {
        maximumFractionDigits: 2,
      })}`;
      totals.duplicate_tickets = total[0].duplicate_ticket_count;
      totals.missing_tickets = total[0].missing_ticket_count;
      totals.locked_loads = total[0].locked_load_count;
      if (adj.length !== 0) {
        totals.adjustment_exists = true;
        totals.total_adjustment = parseFloat(adj[0].total_adjustment);
        totals.total_after_adjustment =
          totals.total_after_adjustment + totals.total_adjustment;
      }
    }

    return totals;
  };

  const handleComments = (inv) => {
    setTriggerComments(true);
    setBody(inv);
  };

  const handleCheck = (inv, idx) => {
    if (batchInvoices.length > 0 && batchInvoices[idx]) {
      if (batchInvoices[idx].checked === true) {
        setBatchInvoices((currentData) => {
          const newData = [...currentData];
          newData[idx] = {
            ...newData[idx],
            invoice_info: null,
            invoice: null,
            checked: false,
          };
          return newData;
        });
        setBatchChecked(false);
      } else {
        setBatchInvoices((currentData) => {
          const newData = [...currentData];
          newData[idx] = {
            ...newData[idx],
            invoice_info: {
              invoice_id: inv.id,
              receiving_company_name: inv.vendor_name,
              sending_company_name: currentCompany.company_name,
              invoice_name: inv.invoice_name,
              user_id: currentUser.id,
              receiving_company_id: inv.target_company_id,
              sending_company_id: inv.company_id,
            },
            invoice: inv,
            checked: true,
          };
          return newData;
        });
      }
    } else {
      setBatchInvoices(
        Array.from({ length: invoices.length }, () => ({
          invoice_info: null,
          invoice: null,
          checked: false,
        })),
      );
      setBatchInvoices((currentData) => {
        const newData = [...currentData];
        newData[idx] = {
          ...newData[idx],
          invoice_info: {
            invoice_id: inv.id,
            receiving_company_name: inv.vendor_name,
            sending_company_name: currentCompany.company_name,
            invoice_name: inv.invoice_name,
            user_id: currentUser.id,
            receiving_company_id: inv.target_company_id,
            sending_company_id: inv.company_id,
          },
          invoice: inv,
          checked: true,
        };
        return newData;
      });
    }
  };

  const handleMail = (inv) => {
    const reqBody = {
      invoice_id: inv.id,
      receiving_company_name: inv.vendor_name,
      sending_company_name: currentCompany.company_name,
      invoice_name: inv.invoice_name,
      user_id: currentUser.id,
      receiving_company_id: inv.target_company_id,
      sending_company_id: currentCompany.id,
    };

    const controller = new AbortController();
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + JwtToken);

    const requestOptions = {
      method: "POST",
      headers,
      body: JSON.stringify(reqBody),
      signal: controller.signal,
    };

    fetch(
      `${process.env.REACT_APP_BACKEND}/pc/vendor-invoice-email`,
      requestOptions,
    )
      .then((res) => {
        if (!res.ok) {
          if (res.status === 401) {
            setAuthStatus(false);
            navigate("/login");
            return;
          } else if (res.status === 403) {
            toggleNewMessage("Forbidden");
            return;
          } else {
            toggleNewMessage(`Something went wrong: ${res.status}`);
          }
        } else {
          toggleNewMessage(null, "Email Sent");
        }
      })
      .catch((err) => {
        console.log(err);
        toggleNewMessage("Something Went Wrong");
      });
    return () => controller.abort();
  };
  
  return !isAsset && invoices ? (
    <>
      {invoices.map(
        (inv, idx) =>
          !inv.is_asset && (
            <tr key={idx} className={inv.email_sent ? "email-sent" : ""}>
              {enableCheckBoxes && (
                <td>
                  <input
                    type="checkbox"
                    name="check_inv"
                    onChange={() => handleCheck(inv, idx)}
                    value={
                      batchInvoices.length > 0 && batchInvoices[idx]
                        ? batchInvoices[idx].checked
                        : false
                    }
                    checked={
                      batchInvoices.length > 0 && batchInvoices[idx]
                        ? batchInvoices[idx].checked
                        : false
                    }
                  />
                </td>
              )}
              <td
                onClick={() => handleClick(inv.id)}
                style={{ cursor: "pointer" }}
              >
                {inv.invoice_name}
              </td>
              <td>
                {getCustInvInfo(
                  inv.account_customer_invoice_id,
                  "cust_invoice",
                )}
              </td>
              <td>{inv.vendor_name}</td>
              <td>{inv.company_type}</td>
              <Dates d={inv.start_date} />
              <Dates d={inv.end_date} />
              {(filter === "approved" || filter === "paid") && (
                <Dates d={inv.approval_date.Time} isApproval={true} />
              )}
              <td>{inv.total_loads}</td>
              <td>
                {parseFloat(inv.total_weight_tons).toLocaleString("en-US", {
                  maximumFractionDigits: 2,
                })}
              </td>
              <td>
                $
                {parseFloat(inv.freight_cost + inv.fsc_cost).toLocaleString(
                  "en-US",
                  { maximumFractionDigits: 2 },
                )}
              </td>
              <td>
                ${getTotals(inv).total_adjustment.toLocaleString("en-US")}
              </td>
              <td>
                ${getTotals(inv).total_after_adjustment.toLocaleString("en-US")}
              </td>
              <td>{getTotals(inv).duplicate_tickets}</td>
              <td>{getTotals(inv).missing_tickets}</td>
              <td>{getTotals(inv).locked_loads}</td>
              <td>
                <div className="d-flex">
                  <div className="invoice-action-col">
                    <img
                      className="account-invoice-action"
                      src={Download}
                      alt="download"
                      onClick={() => handleDownload(inv.id)}
                    />
                  </div>
                  <div className="invoice-action-col">
                    <img
                      className="account-invoice-action"
                      src={pdfPic}
                      alt="pdf_pic"
                      onClick={() => handlePdf(inv)}
                    />
                  </div>
                  {inv.invoice_status_id === 32 &&
                    !getTotals(inv).adjustment_exists && (
                      <div className="invoice-action-col">
                        <img
                          className="account-invoice-action"
                          src={AddCircle}
                          alt="add"
                          onClick={() => {
                            setTriggerAdjustment(true);
                            setBody(inv);
                          }}
                        />
                      </div>
                    )}
                </div>
              </td>
              <td className="status-column">
                <div className="col">{getInvoiceAction(inv)}</div>
              </td>
              <td>
                {inv.invoice_comments !== "" && (
                  <img
                    className="account-invoice-action"
                    src={Open}
                    alt="open"
                    onClick={() => handleComments(inv)}
                  />
                )}
              </td>
            </tr>
          ),
      )}
    </>
  ) : (
    invoices && (
      <>
        {invoices.map(
          (inv, idx) =>
            inv.is_asset && (
              <tr key={idx} className={inv.email_sent ? "email-sent" : ""}>
                {enableCheckBoxes && (
                  <td>
                    <input
                      type="checkbox"
                      name="check_inv"
                      onChange={() => handleCheck(inv, idx)}
                      value={
                        batchInvoices.length > 0 && batchInvoices[idx]
                          ? batchInvoices[idx].checked
                          : false
                      }
                      checked={
                        batchInvoices.length > 0 && batchInvoices[idx]
                          ? batchInvoices[idx].checked
                          : false
                      }
                    />
                  </td>
                )}
                <td
                  onClick={() => handleClick(inv.id)}
                  style={{ cursor: "pointer" }}
                >
                  {inv.invoice_name}
                </td>
                <td>
                  {getCustInvInfo(
                    inv.account_customer_invoice_id,
                    "cust_invoice",
                  )}
                </td>
                <td>{inv.vendor_name}</td>
                <td>{inv.company_type}</td>
                <Dates d={inv.start_date} />
                <Dates d={inv.end_date} />
                {(filter === "approved" || filter === "paid") && (
                  <Dates d={inv.approval_date.Time} isApproval={true} />
                )}
                <td>{inv.total_loads}</td>
                <td>
                  {parseFloat(inv.total_weight_tons).toLocaleString("en-US", {
                    maximumFractionDigits: 2,
                  })}
                </td>
                <td>
                  $
                  {parseFloat(inv.freight_cost + inv.fsc_cost).toLocaleString(
                    "en-US",
                    {
                      maximumFractionDigits: 2,
                    },
                  )}
                </td>
                <td>
                  ${getTotals(inv).total_adjustment.toLocaleString("en-US")}
                </td>
                <td>
                  $
                  {getTotals(inv).total_after_adjustment.toLocaleString(
                    "en-US",
                  )}
                </td>
                <td>{getTotals(inv).locked_loads}</td>
                <td>
                  <div className="d-flex">
                    <div className="invoice-action-col">
                      <img
                        className="account-invoice-action"
                        src={Download}
                        alt="download"
                        onClick={() => handleDownload(inv.id)}
                      />
                    </div>
                    <div className="invoice-action-col">
                      <img
                        className="account-invoice-action"
                        src={pdfPic}
                        alt="pdf_pic"
                        onClick={() => handlePdf(inv)}
                      />
                    </div>
                    {inv.invoice_status_id === 32 &&
                      !getTotals(inv).adjustment_exists && (
                        <div className="invoice-action-col">
                          <img
                            className="account-invoice-action"
                            src={AddCircle}
                            alt="add"
                            onClick={() => {
                              setTriggerAdjustment(true);
                              setBody(inv);
                            }}
                          />
                        </div>
                      )}
                  </div>
                </td>
                <td className="status-column">
                  <div className="col">{getInvoiceAction(inv)}</div>
                </td>
                <td>
                  {inv.invoice_comments !== "" && (
                    <img
                      className="account-invoice-action"
                      src={Open}
                      alt="open"
                      onClick={() => handleComments(inv)}
                    />
                  )}
                </td>
              </tr>
            ),
        )}
      </>
    )
  );
}
